import { IModel, IAttribute, IViolation, ModelConstants } from 'shell-models-lib';
import { Metamodel } from 'app/model/base/model';
import { Activity } from './activity';

import { VariablesConfig } from 'app/model/pipeline/variables-config';
import { ValueAdapter } from 'app/model/adapters/value.adapter';
import { Pipeline } from 'app/model/pipeline/pipeline';
import { stringsAreEqualCaseInsensitive, format } from 'app/shared/utils/string.util';

@Metamodel.model({
    name: ModelConstants.appendVariableActivity,
    display: [
        format(stringResources.ModelName_ActivityTemplate, stringResources.AppendVariables),
        format(stringResources.ModelName_ActivitiesTemplate, stringResources.AppendVariables)
    ],
    referable: true
})
export class AppendVariableActivity extends Activity {
    public static readonly MODEL: IModel;
    public static readonly VALUE: IAttribute;

    @Metamodel.attribute({
        templatable: true,
        display: stringResources.AppendVariables,
        constraint: {
            validator: AppendVariableActivity.validateVariables
        }
    })
    public variables: VariablesConfig;

    @Metamodel.attribute({
        templatable: true,
        display: stringResources.AppendVariables,
        association: 'VALUE',
        accepts: ['Any']
    })
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public value: any;

    constructor(name?: string, description?: string) {
        super(name, description);
        this.activityType = 'ControlActivity';
    }

    private static validateVariables(_variableActivity?: AppendVariableActivity, url?: string): IViolation[] | undefined {
        const violations: IViolation[] = [];
        if (!_variableActivity.variables) {
            violations.push({
                message: () => stringResources.No_Variable_In_Pipeline
            });
        } else if (!_variableActivity.variables || !_variableActivity.variables.name) {
            violations.push({
                message: () => stringResources.Append_Variable_Undefined
            });
        } else if ((!_variableActivity.variables || !_variableActivity.variables.value)) {
            const expressionValue = ValueAdapter.toResource(_variableActivity, AppendVariableActivity.VALUE);
            if (!expressionValue) {
                violations.push({
                    message: () => stringResources.Append_Variable_Value_Undefined
                });
            }
        } else {
            let pipeline = _variableActivity.owner;
            while (pipeline.owner) {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                pipeline = pipeline.owner as any;
            }
            if (pipeline instanceof Pipeline && pipeline.variables) {
                const pipelineVar = pipeline.variables.find((variable) =>
                    variable.name === _variableActivity.variables.name
                );

                if (pipelineVar && !stringsAreEqualCaseInsensitive(pipelineVar._type, 'Array')) {
                    violations.push({
                        message: () => stringResources.Append_Variable_Value_Not_Of_Type
                    });
                } else if (!pipelineVar) {
                    violations.push({
                        message: () => stringResources.Append_Variable_Does_Not_Exists
                    });
                }
            }
        }

        if (violations.length) {
            return violations;
        }
        return violations.length ? violations : undefined;
    }
}
